export default __webpack_public_path__ + "static/media/fav.8b506b0d.svg";